import React from 'react';

const FirmsTable = ({
  firms = [],
  loading = false,
  onView,
  onEdit,
  onStatusChange,
}) => {
  if (loading) {
    return <div className="admin-table-message">Loading firms...</div>;
  }

  if (firms.length === 0) {
    return (
      <div className="admin-table-message">
        <h3>No firms found</h3>
        <p>Create your first firm to get started.</p>
      </div>
    );
  }

  return (
    <div className="admin-table-wrapper">
      <table className="admin-table">
        <thead>
          <tr>
            <th>Firm</th>
            <th>Firm Code</th>
            <th>Contact</th>
            <th>Status</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {firms.map((firm) => {
            const active = firm.status === 'active';

            return (
              <tr key={firm.id}>
                <td>
                  <div className="admin-table-primary">
                    {firm.firm_name}
                  </div>
                  <div className="admin-table-secondary">
                    {firm.owner_name || 'No owner specified'}
                  </div>
                </td>

                <td>{firm.firm_code}</td>

                <td>
                  <div>{firm.mobile || '—'}</div>
                  <div className="admin-table-secondary">
                    {firm.email || '—'}
                  </div>
                </td>

                <td>
                  <span
                    className={`admin-status ${
                      active ? 'active' : 'inactive'
                    }`}
                  >
                    {firm.status || 'unknown'}
                  </span>
                </td>

                <td>
                  {firm.created_at
                    ? new Date(firm.created_at).toLocaleDateString()
                    : '—'}
                </td>

                <td>
                  <div className="admin-table-actions">
                    {onView && (
                      <button
                        type="button"
                        className="admin-button admin-button-secondary"
                        onClick={() => onView(firm)}
                      >
                        View
                      </button>
                    )}

                    {onEdit && (
                      <button
                        type="button"
                        className="admin-button admin-button-secondary"
                        onClick={() => onEdit(firm)}
                      >
                        Edit
                      </button>
                    )}

                    {onStatusChange && (
                      <button
                        type="button"
                        className={`admin-button ${
                          active
                            ? 'admin-button-danger'
                            : 'admin-button-success'
                        }`}
                        onClick={() =>
                          onStatusChange(
                            firm,
                            active ? 'inactive' : 'active'
                          )
                        }
                      >
                        {active ? 'Deactivate' : 'Activate'}
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FirmsTable;